// ©2024 Austin App House. All rights reserved.
import React, { useEffect, useState } from 'react';
import {
  MDBCol, MDBContainer, MDBBtn, MDBRow,
} from 'mdbreact';
import { connect } from 'react-redux';
import getCustomFieldsList from '../../utils/api/get/getCoustomFieldsList';
import Tablet from '../layout/tablet';
import { toggleModal } from '../../storage/actions/modalsActions';
import { manageCustomFieldsTableColumns as columns } from '../../utils/constans';
import ManageCustomFieldsActions from './ManageCustomFieldsActions';
import DashboardIcon from '../dashboard/icons/DashboardIcon';

const Content = ({ isReload, toggleModal }) => {
  const [customFields, setCustomFields] = useState([]);

  const fetchCustomFieldsList = async () => {
    toggleModal(true, 'loader');

    const newCustomFieldsList = await getCustomFieldsList();
    setCustomFields(newCustomFieldsList);

    toggleModal(false, 'loader');
  };

  useEffect(() => {
    fetchCustomFieldsList();
  }, [isReload]);

  return (
    <div className="subpage-wrap">
      <div className="subpage-header">
        <h1 className="subpage-title">Custom Fields</h1>
        <button
          className="subpage-btn subpage-btn--gold"
          type="button"
          aria-label="Add custom fields"
          onClick={() => toggleModal(true, 'addOrEditCustomFields')}
        >
          <DashboardIcon name="plus" size={18} strokeWidth="2.5" />
          Add Custom Fields
        </button>
      </div>

      <div className="subpage-table-scroll">
        <Tablet
          columns={columns}
          rows={customFields}
          className="subpage-table custom_fields"
          enableActionsCol
          ActionElement={ManageCustomFieldsActions}
          placeholder="No custom fields yet"
        />
      </div>
    </div>
  );
};

const mapDispatchToProps = {
  toggleModal,
};

const mapStateToProps = state => ({
  isReload: state.applicationState.isReload,
});

export default connect(mapStateToProps, mapDispatchToProps)(Content);
